export const formatHour = (time?: string | null): string => {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  return minutes ? `${hours}:${minutes}` : hours;
};

const formatHourRange = (start?: string | null, end?: string | null): string => {
  const from = formatHour(start);
  const to = formatHour(end);
  return from && to ? `${from} - ${to}` : '';
};

export default formatHourRange;
